import { Fragment, h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Storefront from 'utils/storefront';
import * as queries from 'utils/storefront/queries';
import ProductCard from 'utils/product-card';
import WishlistContext from 'utils/gift-reggie/wishlist-context';
import { edgesToNodes } from 'utils/storefront/format-resource';
import SkeletonLoader from './skeleton-loader';

const ProductGrid = (props) => {
  const storefront = Storefront.getInstance();
  const [products, setProducts] = useState(props.collection.products || []);

  const getCollection = async () => {
    const response = await storefront.request({
      query: queries.collectionGet,
      variables: {
        id: props.collection.id,
        first: 50,
      },
    });

    if (!response.data) {
      // eslint-disable-next-line no-console
      console.error(
        'product-grid/product-grid.js: Storefront API request failed',
        response,
      );
      return [];
    }

    return edgesToNodes(response.data.collection.products, 'product');
  };

  useEffect(() => {
    if (products.length) return;
    setProducts(getCollection());
  }, []);

  useEffect(() => {
    if (products.length) {
      const event = new CustomEvent('productCardsRendered', {
        detail: { products },
      });
      window.dispatchEvent(event);
    }
  }, [products]);

  return products.length ? (
    <WishlistContext>
      <Fragment>
        <div
          className="grid grid-cols-2 gap-1.5 gap-y-[1.375rem] mb-[30px] md:gap-y-[3.25rem] md:grid-cols-4 md:px-10"
          data-collection
        >
          {products.map((product) => (
            <ProductCard key={product.id} product={product} {...props} />
          ))}
        </div>
      </Fragment>
    </WishlistContext>
  ) : (
    <SkeletonLoader />
  );
};

export default ProductGrid;
